import DefaultMapper, {
	mapId,
	mapIdInList,
	addCustomMethods
} from '../../dataProvider/DefaultMapper';
import { API_BASE_PATH_ADMIN } from '../../constants';

class WalletMapper extends DefaultMapper {
	mapResource() {
		return 'wallet/wallets';
	}

	finishGetList({ result }) {
		return mapIdInList(super.finishGetList({ result }), 'walletId');
	}

	finishGetOne({ type, resource, params, options, mappedResource, result }) {
		return mapId(super.finishGetOne({ result }), 'walletId');
	}

	prepareCreate({ type, resource, params, options, mappedResource }) {
		options.method = 'POST';
		switch (params.action) {
			case 'CreateWalletAccount':
				options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${params.id}/accounts`;
				options.body = JSON.stringify({
					currency: params.data.currencyCode,
					name: params.data.name
				});
				break;
			default:
				// Cases: LockWallet/UnlockWallet and TerminateWallet
				options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${
					params.id
				}${addCustomMethods(params)}`;
				options.body = JSON.stringify({
					description: params.data.description
				});
				break;
		}
	}

	finishCreate({ type, resource, params, options, mappedResource, result }) {
		return mapId(super.finishCreate({ type, resource, params, options, mappedResource, result }), 'walletId');
	}

}

export default WalletMapper;
